import { userAgent } from '@tink/tink-link-core/src/user-agent-detector';
import { useMemo } from 'react';
import { Provider, ProviderEntity } from '../../../models/provider';
import { useApplicationEvent } from '../../../core/Analytics/useApplicationEvent';
import { ApplicationEvent } from '../../../models/analytics';
import {
  AuthenticationOption,
  AuthenticationOptionDefinition,
  AuthenticationOptionsGroup,
} from '../../../connectivity/services/credentialsClient';

type UseSelectedAuthenticationOptions = (selectedProvider: Pick<ProviderEntity, 'name'>) => {
  selectedAuthenticationOptions: AuthenticationOption[] | undefined;
};

export const useSelectedAuthenticationOptions: UseSelectedAuthenticationOptions = (
  selectedProvider
) => {
  const { sendEvent } = useApplicationEvent();

  return useMemo(() => {
    const { isDesktop } = userAgent;

    if (!Provider.isRequiringAnimatedQRCode(selectedProvider.name)) {
      return { selectedAuthenticationOptions: undefined };
    }

    if (!isDesktop) {
      sendEvent(ApplicationEvent.AUTH_OPTIONS_SAME_DEVICE);

      return { selectedAuthenticationOptions: undefined };
    }

    sendEvent(ApplicationEvent.AUTH_OPTIONS_OTHER_DEVICE);

    return {
      selectedAuthenticationOptions: [
        {
          authenticationOptionsGroup: AuthenticationOptionsGroup.SE_MOBILE_BANKID_DEVICE_CHOICE,
          authenticationOptionDefinition:
            AuthenticationOptionDefinition.SE_MOBILE_BANKID_OTHER_DEVICE,
        },
      ],
    };
  }, [selectedProvider.name, sendEvent]);
};
